import httpService from "./http.service"
import apiEndpoint from "./config"

const messagingService = {
  listConversations: async (params = {}) => {
    const { data } = await httpService.get("api/messaging/conversations", { params })
    return data
  },

  getConversation: async (conversationId) => {
    const { data } = await httpService.get(
      `api/messaging/conversations/${conversationId}`
    )
    return data
  },

  patchConversation: async (conversationId, payload) => {
    const { data } = await httpService.patch(
      `api/messaging/conversations/${conversationId}`,
      payload
    )
    return data
  },

  claimConversation: async (conversationId) => {
    const { data } = await httpService.post(
      `api/messaging/conversations/${conversationId}/claim`
    )
    return data
  },

  releaseConversation: async (conversationId) => {
    const { data } = await httpService.post(
      `api/messaging/conversations/${conversationId}/release`
    )
    return data
  },

  closeConversation: async (conversationId) => {
    const { data } = await httpService.post(
      `api/messaging/conversations/${conversationId}/close`
    )
    return data
  },

  reopenConversation: async (conversationId) => {
    const { data } = await httpService.post(
      `api/messaging/conversations/${conversationId}/reopen`
    )
    return data
  },

  markRead: async (conversationId, payload = {}) => {
    await httpService.post(
      `api/messaging/conversations/${conversationId}/read`,
      payload
    )
  },

  unreadSummary: async () => {
    const { data } = await httpService.get("api/messaging/unread-summary")
    return data
  },

  listMessages: async (conversationId, params = {}) => {
    const { data } = await httpService.get(
      `api/messaging/conversations/${conversationId}/messages`,
      { params }
    )
    return data
  },

  sendMessage: async (conversationId, payload, clientMessageId) => {
    const { data } = await httpService.post(
      `api/messaging/conversations/${conversationId}/messages`,
      payload,
      {
        headers: {
          "Idempotency-Key": clientMessageId,
        },
      }
    )
    return data
  },

  retryMessage: async (messageId) => {
    const { data } = await httpService.post(
      `api/messaging/messages/${messageId}/retry`
    )
    return data
  },

  uploadAttachment: async (conversationId, clientUploadId, file) => {
    const form = new FormData()
    form.append("conversationId", conversationId)
    form.append("clientUploadId", clientUploadId)
    form.append("file", file)
    const { data } = await httpService.post("api/messaging/uploads", form)
    return data
  },

  attachmentUrl: (attachmentId) =>
    `${apiEndpoint}api/messaging/attachments/${attachmentId}/content`,

  clientSuggestions: async (conversationId, q) => {
    const { data } = await httpService.get(
      `api/messaging/conversations/${conversationId}/client-suggestions`,
      { params: q ? { q } : {} }
    )
    return data
  },

  linkClient: async (conversationId, payload) => {
    const { data } = await httpService.put(
      `api/messaging/conversations/${conversationId}/client-link`,
      payload
    )
    return data
  },

  unlinkClient: async (conversationId, payload) => {
    const { data } = await httpService.delete(
      `api/messaging/conversations/${conversationId}/client-link`,
      { data: payload }
    )
    return data
  },

  createClientFromChat: async (conversationId, payload) => {
    const { data } = await httpService.post(
      `api/messaging/conversations/${conversationId}/client`,
      payload
    )
    return data
  },

  listChannelAccounts: async () => {
    const { data } = await httpService.get("api/messaging/channel-accounts")
    return data
  },

  connectInstagram: async () => {
    const { data } = await httpService.post(
      "api/messaging/channel-accounts/instagram/connect"
    )
    return data
  },

  testChannel: async (accountId) => {
    const { data } = await httpService.post(
      `api/messaging/channel-accounts/${accountId}/test`
    )
    return data
  },

  backfillChannel: async (accountId) => {
    const { data } = await httpService.post(
      `api/messaging/channel-accounts/${accountId}/backfill`
    )
    return data
  },

  reauthorizeChannel: async (accountId) => {
    const { data } = await httpService.post(
      `api/messaging/channel-accounts/${accountId}/reauthorize`
    )
    return data
  },

  disconnectChannel: async (accountId) => {
    await httpService.delete(`api/messaging/channel-accounts/${accountId}`)
  },

  createRealtimeTicket: async () => {
    const { data } = await httpService.post("api/messaging/realtime-ticket")
    return data
  },

  wsUrl: (ticket, after) => {
    const base = apiEndpoint.replace(/^http/, "ws").replace(/\/$/, "")
    const params = new URLSearchParams({ ticket })
    if (after) params.set("after", after)
    return `${base}/api/messaging/ws?${params.toString()}`
  },
}

export default messagingService
